/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "5591e6dc8068340fe78ad9686b41d5b83fa909f9";
